import {useSearchParams} from 'next/navigation';

export default function useIsDebug(force = false) {
	const searchParams = useSearchParams();
	return Boolean(force || !!searchParams.get('debug'));
}
